<template lang="pug">
	div.detail-summary
		p.detail-label Application Summary:
		table.detail-summaryTable
			transition-group.detail-summaryTbody(
				name="detail-summaryTbody",
				tag="tbody")
				tr.detail-summaryRow(
					v-for="(item, i) in summary",
					:key="item.Text + item.Amount + item.Discount + item.Refundable") 
					th.detail-summaryCell
						span.detail-summaryContent {{ item.Text }}{{ item.Refundable ? ' (Refundable)' : ' (Non-Refundable)' }}:
					td.detail-summaryCell(v-if="item.Discount == 0 && !item.Waived") 
						span.detail-summaryContent {{item.Amount | currency}}
					td(v-else-if="item.Waived")
						span.detail-summaryContent 
							span.detail-summaryStrike {{item.Amount | currency}}
							span.detail-summaryReduced $0
					td.detail-summaryCell(v-else) 
						span.detail-summaryContent 
							span.detail-summaryStrike {{item.Amount | currency}}
							span.detail-summaryReduced {{ item.Amount-item.Discount | currency}}
</template>

<script>
export default {
	name: "Summary",
	props: ["summary"],
  data() {
    return { }
  },
	filters: {
		currency(val) {
			return '$' + parseInt(val).toLocaleString()
		}
	}
}
</script>

<style lang="scss" scoped>
.detail-upgrades,
.detail-layouts {
  & ~ .detail-summary {
    border-top: 1px solid #c9c9c8;
  }
}

.detail-label {
	font-family: HelveticaNeueW02-57Cn !important;
}

.detail-summary {
  margin-bottom: 20px;
  padding-top: 20px;
	color: $mediumGray;
}

.detail-summaryTable{
	border-collapse: collapse;
	border-spacing: 0;
}

.detail-summaryTbody {
	&-enter,
	&-leave-to {
		opacity: 0;
		transform: translateX(-30px);
	}
	&-leave-active {
		position: absolute;
	}
}

.detail-summaryRow {
	transition: all 0.5s ease;
}

.detail-summaryCell {
	padding: 0;
	width: auto;
}

th.detail-summaryCell {
	.detail-summaryContent {
		padding-right: 12px;
		font-weight: 700;
		font-family: HelveticaNeueW02-57Cn;
	}
}

.detail-summaryContent {
	display: flex;
  font-size: 16px;
	font-family: HelveticaNeueW02-57Cn;
}

.detail-summaryStrike {
	text-decoration: line-through;
	margin-right: 8px;
}

.detail-summaryReduced {
	color: #d11046;
}
</style>
